export default {
  namespaced  : true,
  
  state       : {
    shouldOpenEntrance  : false,
    shouldOpenFinal     : false,

    shouldOpenTour      : {
      home        : false,
      office      : false,
      park        : false,
      connection  : false
    },

    tourType  : 'single', // [single | through]
  },

  mutations   : {
    setTourType(state, value){
      state.tourType = value
    },

    setShouldOpenEntrance(state, value){
      state.shouldOpenEntrance = value;
    },

    setShouldOpenFinal(state, value){
      state.shouldOpenFinal = value;
    },

    setShouldOpenTour(state, payload){
      state.shouldOpenTour[payload.name] = payload.value;
    }
  },

  actions     : {
    updateTourType(context, payload){
      context.commit('setTourType', payload.value);
    },

    updateShouldOpenEntrance(context, payload){
      context.commit('setShouldOpenEntrance', payload.value);
    },

    updateShouldOpenFinal(context, payload){
      context.commit('setShouldOpenFinal', payload.value);
    },

    updateSingleShouldOpenTour(context, payload){
      context.commit('setShouldOpenTour', {
        name  : payload.name,
        value : payload.value
      });
    },

    updateShouldOpenTour(context, payload){
      if(typeof payload.name === 'undefined') payload.name = '';

      for(let i in context.state.shouldOpenTour){
        if(i === payload.name) continue;

        context.commit('setShouldOpenTour', {
          name  : i,
          value : false
        });
      }

      if(payload.name !== ''){
        context.commit('setShouldOpenTour', {
          name  : payload.name,
          value : true
        });
      }
    }
  }
}